<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />

    <ul :class="['no-bullet-list', 'typography-list']">
      <li v-for="(style, index) in typography" :key="index">
        <div :class="[style.cssClass, 'font-grey', 'font-l-600', 'typography-sample']">
          {{ style.label }}
        </div>
        <div>
          <strong>.{{ style.cssClass }}</strong>, <span>font-weight: <strong>{{ style.fontWeight }}</strong></span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'TypographyPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      typography: [{
        cssClass: 'display-4',
        fontWeight: 300,
        label: 'Light 112px'
      }, {
        cssClass: 'display-3',
        fontWeight: 400,
        label: 'Regular 56px'
      }, {
        cssClass: 'display-2',
        fontWeight: 400,
        label: 'Regular 45px'
      }, {
        cssClass: 'display-1',
        fontWeight: 400,
        label: 'Regular 34px'
      }, {
        cssClass: 'headline',
        fontWeight: 400,
        label: 'Regular 24px'
      }, {
        cssClass: 'title',
        fontWeight: 500,
        label: 'Medium 20px'
      }, {
        cssClass: 'subheading',
        fontWeight: 400,
        label: 'Regular 16px'
      }, {
        cssClass: 'body-2',
        fontWeight: 500,
        label: 'Medium 14px'
      }, {
        cssClass: 'body-1',
        fontWeight: 400,
        label: 'Regular 14px'
      }, {
        cssClass: 'caption',
        fontWeight: 400,
        label: 'Regular 12px'
      }]
    }
  },
  mounted () {
    this.getPage()
  }
}
</script>
<style>
.typography-list li
{
  padding: 8px 0;
}

.typography-sample
{
  padding: 0 0 16px;
}

.typography-sample + div
{
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/typography.vue